import {log} from "./util/log";

export interface IClientConfig {
    exclude_gdpr?: boolean;
}

class ClientConfig {
    /* STATIC */

    /* INSTANCE */
    public constructor(private readonly _data: IClientConfig) {
    }

    private get data(): IClientConfig {
        return this._data;
    }

    public get exclude_gdpr(): boolean {
        return this.data.exclude_gdpr ?? false;
    }
}

let instance: ClientConfig|null = null;
export default (): ClientConfig => {
    const clientConfig = (window as any).__cmpclientconfig;
    if (!clientConfig) {
        log.debug(`No se han encontrado datos de configuración del cliente. Se utilizarán los valores por defecto.`);
    } else {
        log.debug(`Se ha encontrado datos de configuración del cliente`, clientConfig);
    }
    return instance ??= new ClientConfig(clientConfig||{});
}
